import { useEffect, useRef } from 'react';

/**
 * Faz scroll para o topo da página sempre que `phaseKey` muda.
 *
 * O <ScrollToTop> global (em App.tsx) só reage a mudanças de pathname, pelo
 * que transições internas que ocorrem dentro da mesma rota — por exemplo
 * escolher a próxima personagem no ecrã de espera, ou avançar do ecrã de
 * "pronto" para a conversa — não rebobinam o scroll e a página fica "cá em
 * baixo". Este hook cobre esses casos: sempre que a fase visual muda, a
 * página volta ao topo.
 *
 * Ignora a primeira execução (a montagem é tratada pelo ScrollToTop global
 * ou pelo posicionamento natural da rota), evitando um scroll redundante.
 */
export function useScrollToTopOnPhaseChange(phaseKey: unknown): void {
  const prevKey = useRef<unknown>(phaseKey);

  useEffect(() => {
    if (prevKey.current === phaseKey) return;
    prevKey.current = phaseKey;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [phaseKey]);
}
